import { Input } from '@/components/ui/input'
import { LucideCalendar } from 'lucide-react'
import { useRef, useEffect, useState } from 'react'

const formatMonthYear = (value: string) => {
  if (!value) return ''
  const onlyNumbers = value.replace(/\D/g, '').slice(0, 6) // limita a 6 dígitos
  return onlyNumbers.replace(/^(\d{2})(\d{0,4})$/, (_, mm, yyyy) => `${mm}${yyyy ? '/' + yyyy : ''}`)
}

export function MesAnoInput({
  value, // <- vem como "MMYYYY"
  onChange,
  disabled = false
}: {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}) {
  const [displayIcon, setDisplayIcon] = useState(true)
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const onlyNumbers = e.target.value.replace(/\D/g, '').slice(0, 6) // limitar para não exceder 6 dígitos
    onChange(onlyNumbers)
  }
  const inputRef = useRef<HTMLInputElement>(null)
  useEffect(() => {
    const inputContainerWidth = inputRef.current?.offsetWidth
    if (inputContainerWidth && inputContainerWidth < 120) {
      setDisplayIcon(false)
    }
  }, [inputRef.current])

  return (
    <div className="relative">
      <Input
        ref={inputRef}
        type="text"
        inputMode="numeric"
        pattern="\d{2}/\d{4}"
        placeholder="MM/AAAA"
        maxLength={7}
        value={formatMonthYear(value)}
        onChange={handleChange}
        disabled={disabled}
        className="bg-input text-foreground relative"
      />
      {displayIcon && (
        <LucideCalendar className="absolute right-3 top-1/2 transform -translate-y-1/2 text--secondary" />
      )}
    </div>
  )
}
